import { RefObject, useEffect } from 'react';

type Handler = (event: MouseEvent) => void;

function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: Handler,
  mouseEvent: 'mousedown' | 'mouseup' = 'mousedown',
): void {
  const handleClickOutside = (event: MouseEvent): void => {
    const element = ref?.current;

    // Do nothing if clicking ref's element or descendent elements
    if (element == null || element.contains(event.target as Node)) {
      return;
    }

    handler(event);
  };

  useEffect(() => {
    document.addEventListener(mouseEvent, handleClickOutside, true);
    return () => {
      document.removeEventListener(mouseEvent, handleClickOutside, true);
    };
  }, []);
}

export default useOnClickOutside;
